import Input from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import cx from 'classnames';
import InputLabel from '@mui/material/InputLabel';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import styles from '@/common/components/Inputs/Select/styles.less';

const Autocomplete = ({
  className,
  name,
  options,
  label,
  tip,
  required,
  rules,
  onChangeFormat = (value) => value,
  ...props
}) => {
  const { control } = useFormContext() || {};

  return (
    <div className={cx(styles.container, className)}>
      <Controller
        defaultValue=""
        name={name}
        control={control}
        rules={rules}
        render={({
          field: { onChange, value, name },
          fieldState: { error },
        }) => (
          <>
            <InputLabel
              className={cx(styles.label, error && styles['label-error'])}
              htmlFor={name}
            >
              {label}
              {required && <span className={styles.labelRequired}>*</span>}
            </InputLabel>
            <Input
              freeSolo
              value={value}
              onInputChange={(event, value, reason) => {
                onChange(onChangeFormat(value));
              }}
              id="free-solo-2-demo"
              disableClearable
              options={options.map((op) => op.value)}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '4px',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  borderRadius: '4px',
                },
                '& .MuiAutocomplete-inputRoot': {
                  padding: '0 !important',
                },
                '& .MuiAutocomplete-input': {
                  padding: '16px 12px !important',
                  minHeight: '24px',
                },
              }}
              {...props}
              getOptionLabel={(option) => {
                if (typeof option === 'string') {
                  return option;
                }
                if (option.inputValue) {
                  return option.inputValue;
                }
                return option || '';
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  slotProps={{
                    input: {
                      ...params.InputProps,
                    },
                  }}
                />
              )}
            />
            <InputLabel
              className={cx(
                styles.bottomLabel,
                !!error && styles['bottomLabel-error']
              )}
              htmlFor={name}
            >
              {error?.message || tip}
            </InputLabel>
          </>
        )}
      />
    </div>
  );
};

export default Autocomplete;
